import { API } from '../Api';

// "Mục tiêu donate" của streamer: đặt mục tiêu rồi chèn thanh tiến độ lên phiên live.
// Khác "Quyên góp" (/donate-goal page) vốn là chiến dịch gây quỹ có eKYC/rút tiền.

export interface DonateGoal {
  exists: boolean;
  title: string;
  targetAmount: number;
  currentAmount: number; // BE tính lại từ giao dịch thật mỗi lần gọi
  percent: number; // 0-100, đã kẹp trần
  isActive: boolean;
  startedAt: string | null;
  endAt: string | null;
  isExpired: boolean;
  description?: string | null;
  /** Số lượt donate được tính vào mục tiêu. */
  donationCount?: number;
  /** Giao diện thanh trên live: chuỗi JSON thô, đọc bằng parseDonateGoalTheme. */
  theme?: string | null;
}

export interface SaveDonateGoalBody {
  title: string;
  targetAmount: number;
  endAt?: string | null;
  isActive: boolean;
  /** Tối đa 100 ký tự, BE tự cắt khoảng trắng hai đầu. */
  description?: string | null;
  /** Đặt lại mốc tính tiến độ về hiện tại (bắt đầu chặng mới). */
  resetProgress?: boolean;
  /**
   * Giao diện thanh trên live. null = giữ nguyên, "" = về mặc định,
   * còn lại là chuỗi JSON (≤ 1000 ký tự).
   */
  theme?: string | null;
}

export const getMyDonateGoal = () =>
  API.get<DonateGoal>('/v1/payment-service/donate-goal/me').then((r) => r.data);

export const saveDonateGoal = (body: SaveDonateGoalBody) =>
  API.post<DonateGoal>('/v1/payment-service/donate-goal', body).then((r) => r.data);

// Công khai — overlay OBS gọi được mà không cần đăng nhập.
export const getPublicDonateGoal = (userId: string) =>
  API.get<DonateGoal>('/v1/payment-service/public/creator-donate-goal', {
    params: { userId },
  }).then((r) => r.data);
